export default {
    routerName: '广告编辑',
    routerNamePic: '图片裁剪',
    ad: {
        adSpace: '广告位',
        id: 'ID',
        name: '广告名',
        description: '描述',
        thumb: '缩略图',
        image: '图片',
        link: '链接',
        sortOrder: '排序',
        hits: '浏览量',
        category: '类别',
        hot: '热门',
        recommend: '推荐',
        recommendTop: '推荐TOP',
        topic: '话题',
        type: '类型',
        typeImage: '图片',
        typeVideo: '正视频',
        typeRadio: '音频',
        pattern: '投放模式',
        startTime: '模式启用时间',
        endTime: '模式停用时间',
        patternHits: '模式浏览量',
        pDay: '按天起止',
        pHits: '按浏览量起止',
        status: '状态',
        open: '启用',
        close: '禁用',
    },
};
